import { render, staticRenderFns } from "./practiceResult.vue?vue&type=template&id=0b627c4b&scoped=true"
import script from "./practiceResult.vue?vue&type=script&lang=js"
export * from "./practiceResult.vue?vue&type=script&lang=js"
import style0 from "./practiceResult.vue?vue&type=style&index=0&id=0b627c4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b627c4b",
  null
  
)

export default component.exports